import { render, staticRenderFns } from "./tableData.vue?vue&type=template&id=7d988a48"
import script from "./tableData.vue?vue&type=script&lang=js"
export * from "./tableData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d988a48')) {
      api.createRecord('7d988a48', component.options)
    } else {
      api.reload('7d988a48', component.options)
    }
    module.hot.accept("./tableData.vue?vue&type=template&id=7d988a48", function () {
      api.rerender('7d988a48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/bank/components/tableData.vue"
export default component.exports